import ApiService, { callCustomMethodAsync } from "../service/ApiService";

let moduleApi = {};
let moduleName = "document";

moduleApi.create = async (dataForm) => {
  let api = {
    module: moduleName,
    type: "create",
    value: dataForm,
    message: {
      success: "hidden",
      error: "hidden"
    }
  };

  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.update = async (dataForm) => {
  let api = {
    module: moduleName,
    type: "partialUpdate",
    value: dataForm,
    message: {
      success: "hidden",
      error: "hidden"
    }
  };

  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.list = async (dataFilter, loading) => {
  let api = {
    module: moduleName,
    type: "list",
    value: dataFilter,
    dontLoading: true,
  };

  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.delete = async (id) => {
  let api = {
    module: moduleName,
    type: "delete",
    value: { id: id },
    message: {
      success: "hidden",
      error: "hidden"
    }
  };

  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.findById = async (id, loading) => {
  let api = {
    module: moduleName,
    type: "findById",
    value: { id: id },
    dontLoading: (loading == undefined ? false : loading ),
  };

  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.SignForApproval = async (dataBody) => {
  let api = {
    module: moduleName,
    body: dataBody,
    type: "SignForApproval",
    message: {
      success: "hidden",
      error: "hidden"
    }
  };
  const result = await callCustomMethodAsync(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.SignForReject = async (dataBody) => {
  let api = {
    module: moduleName,
    body: dataBody,
    type: "SignForReject",
    message: {
      success: "hidden",
      error: "hidden"
    }
  };
  const result = await callCustomMethodAsync(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.SignForApprovalDraff = async (dataBody) => {
  let api = {
    module: moduleName,
    body: dataBody,
    type: "SignForApprovalDraff",
    message: {
      success: "hidden",
      error: "hidden"
    }
  };
  const result = await callCustomMethodAsync(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.SignForRejectDraff = async (dataBody) => {
  let api = {
    module: moduleName,
    body: dataBody,
    type: "SignForRejectDraff",
    message: {
      success: "hidden",
      error: "hidden"
    }
  };
  const result = await callCustomMethodAsync(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.TransferDocument = async (dataBody) => {
  let api = {
    module: moduleName,
    body: dataBody,
    type: "TransferDocument",
    message: {
      success: "hidden",
      error: "hidden"
    }
  };
  const result = await callCustomMethodAsync(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.PublishDocument = async (dataBody) => {
  let api = {
    module: moduleName,
    body: dataBody,
    type: "PublishDocument",
    message: {
      success: "hidden",
      error: "hidden"
    }
  };
  const result = await callCustomMethodAsync(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.RecallDocument = async (id) => {
  let api = {
    module: moduleName,
    body: { id: id},
    type: "RecallDocument",
    message: {
      success: "hidden",
      error: "hidden"
    }
  };
  const result = await callCustomMethodAsync(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.RequestSignDocument = async (dataBody) => {
  let api = {
    module: moduleName,
    body: dataBody,
    type: "RequestSignDocument",
    message: {
      success: "hidden",
      error: "hidden"
    }
  };
  const result = await callCustomMethodAsync(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.RequestTempSignDocument = async (dataBody) => {
  let api = {
    module: moduleName,
    body: dataBody,
    type: "RequestTempSignDocument",
    message: {
      success: "hidden",
      error: "hidden"
    }
  };
  const result = await callCustomMethodAsync(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.SearchDocument = async (dataBody) => {
  let api = {
    module: moduleName,
    body: dataBody,
    type: "SearchDocument",
    message: {
      success: "hidden",
      error: "hidden"
    },
    dontLoading: true,
  };
  const result = await callCustomMethodAsync(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.ViewSignOnPdf = async (dataBody) => {
  let api = {
    module: moduleName,
    body: dataBody,
    type: "ViewSignOnPdf",
    message: {
      success: "hidden",
      error: "hidden"
    }
  };
  const result = await callCustomMethodAsync(api);
  mushroom[moduleName].invalidCache();
  return result;
}

moduleApi.RejectSignRequest = async (id) => {
  let api = {
    module: moduleName,
    body: { id: id },
    type: "RejectSignRequest",
    message: {
      success: "hidden",
      error: "hidden"
    }
  };
  const result = await callCustomMethodAsync(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.ReadDocument = async (id) => {
  let api = {
    module: moduleName,
    body: { id: id},
    type: "ReadDocument",
    message: {
      success: "hidden",
      error: "hidden"
    }
  };
  const result = await callCustomMethodAsync(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.TransferDocumentForOtherCompany = async (data) => {
  let api = {
    module: moduleName,
    body: data,
    type: "TransferDocumentForOtherCompany",
    message: {
      success: "hidden",
      error: "hidden"
    }
  };
  const result = await callCustomMethodAsync(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.TransferDocumentAgainToRefCompany = async (id) => {
  let api = {
    module: moduleName,
    body: { id: id },
    type: "TransferDocumentAgainToRefCompany",
    message: {
      success: "hidden",
      error: "hidden"
    }
  };
  const result = await callCustomMethodAsync(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.HashDocumentToSign = async (data) => {
  let api = {
    module: moduleName,
    body: data,
    type: "HashDocumentToSign",
    message: {
      success: "hidden",
      error: "hidden"
    }
  };
  const result = await callCustomMethodAsync(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.InsertSignatrue = async (data) => {
  let api = {
    module: moduleName,
    body: data,
    type: "InsertSignatrue",
    message: {
      success: "hidden",
      error: "hidden"
    }
  };
  const result = await callCustomMethodAsync(api);
  mushroom[moduleName].invalidCache();
  return result;
};

export default moduleApi;
